import { AxiosResponse } from "axios";
import appConstants from "../config/app-constants";

import InitApi from "./init";

export default class CategoryApi {
	static _instance: CategoryApi;

	static getInstance = () => {
		if (this._instance) {
			return this._instance;
		}
		this._instance = new CategoryApi();
		return this._instance;
	};

	_apiSvc;

	constructor() {
		this._apiSvc = InitApi.getInstance();
	}

	getCategory = async (page: number): Promise<AxiosResponse> => {
		let url = `${appConstants.apiUrl}/categories?_fields=id,name,link,description,parent,count,slug,acf&per_page=500`;

		if (page) {
			url = url + `&page=${page}`;
		}
		return this._apiSvc.get(url);
	};

	getDefaultTags = async (): Promise<AxiosResponse> => {
		const url = `${appConstants.apiUrl}/tags?_fields=id,count,name,description,link&per_page=100`;
		return this._apiSvc.get(url);
	};

	getExcludedAndWithoutCurrencyCategories =
		async (): Promise<AxiosResponse> => {
			const url = `${appConstants.apiUrl}/excluded-and-parent-categories`;
			return this._apiSvc.get(url);
		};

	getProducts = async():Promise<AxiosResponse>=>{
		const url = `${appConstants.apiUrl}/product?_fields=id,name,slug,acf`;
		return this._apiSvc.get(url)
	}
}
